<<template>  
  <prop-panel @close="close" :width='"350px"'>
    <p slot="header">列定义</p>
    
    <div class="row" style="margin-left:0; height: 500px; overflow: auto;">
      <!--div class="color-list">
          <div
              class="color-item"
              v-for="(color,idx) in colors" v-dragging="{ item: color, list: colors}"
              :key="color.text"
          ><input type="text" @keypress.stop="kd" v-model="color.text">{{idx}}</div>
      </div-->
      <draggable v-model="nlist" class="dragArea" :options="{ animation:300 }">
        <div v-for="(element, index) in nlist" class="drag-item">
          
          <button @click="removeItem(index)" style="float: left;width:25px;">X</button>
          <span class="name" style="float: right;">{{ index+1 }}</span>
          <input type="text" v-model="element.showName" style="margin-left: 10px;">
        </div>
      </draggable>
    </div>
    <div slot="footer">
      <button @click.stop="add" type="button" class="btn btn-primary">添加列</button>
      <button @click.stop="close" type="button" class="btn btn-default" data-dismiss="modal">{{rs["btn_close"]}}</button>
      <button @click.stop="create" type="button" class="btn btn-primary">确定</button>
    </div>
  </prop-panel>
</template>

<<script>
import draggable from 'vuedraggable'
export default {
  created(){
    this.nlist = this.dfList? this.dfList:[]
  },
  props:["rs", "dfList"],
  data(){
    return {
      nlist:[],
      showName:"",
      sort:""
    }
  },
  methods:{
    add(){
      this.nlist.push({showName:"", sort:0})
    },
    close: function() {
      this.$emit("close")
    },

    replaceAll: function(s0,s1,s2){     
        return s0.replace(new RegExp(s1,"gm"),s2);     
    },
    removeItem(idx){
      this.nlist.splice(idx,1)
    },
    create(){
      //console.log(this.nlist)
      this.nlist.forEach((d,idx)=>{
        d.sort = idx + 1
      })
      this.$emit("save", this.nlist)
    }
  },
  components: {
    draggable
  }
}
</script>

<<style >
    .test{
        border:1px solid #ccc;
    }
    .drag-item{
        width: 250px;
        height: 30px;
        margin-top: 5px;
        background-color: #c8c8c8;
        vertical-align: middle;
    }
    .ghostClass{
        opacity: 1;
    }
    .bottom{
        width: 200px;
        height: 20px;
        position: relative;
        background: blue;
        top:2px;
        left: 2px;
        transition: all .5s linear;
    }
</style>
